<h2 mat-dialog-title class="default-dialog-header">
	<span fxFlex> Search Contacts </span>
	<span fxFlex="10" fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer"> close </mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content class="default-dialog-content font-size-12">
	<div fxLayout="row" fxLayoutAlign="center center" class="m-t-1 m-b-1">
		<app-contact-autocomplete
			fxFlex="70"
			[carrierId]="data?.carrierId"
			(contactSelected)="contactSelected($event)"
			[contactList]="contactList"
		></app-contact-autocomplete>
	</div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end end" fxLayoutGap="1rem">
		<button
			*ngIf="!isUpdating"
			color="primary"
			mat-raised-button
			[disabled]="IS_NULL_OR_UNDEFINED(selectedContact)"
			(click)="selectContactForProject()"
		>
			Select for Project
		</button>
		<mat-spinner *ngIf="isUpdating" [diameter]="30"></mat-spinner>
	</div>
</mat-dialog-actions>
